import type { InputHTMLAttributes } from 'react'

import { Input } from './FormControls'
import { formatMinorUnitInput, formatPastedMoneyInput } from '../lib/ledger'

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'onPaste' | 'type'> & {
  onValueChange: (value: string) => void
}

export default function MoneyInput({ onValueChange, ...props }: Props) {
  return <Input {...props} inputMode="decimal" type="text"
    onChange={(event) => onValueChange(formatMinorUnitInput(event.target.value))}
    onPaste={(event) => {
      const value = formatPastedMoneyInput(event.clipboardData.getData('text'))
      if (value === null) return
      event.preventDefault()
      onValueChange(value)
    }}
  />
}
